module.exports = __webpack_public_path__ + "static/media/logo_tornado.bd4451c0.png";